<template>
    <div>
        <div
            v-for="project_phase in projectPhases"
            :key="project_phase.id"
            class="uk-panel uk-panel-box uk-margin-bottom"
        >
            <h3 class="uk-panel-title">{{ project_phase.name }}</h3>

            <div v-if="project_phase.code_constant==='incentives'">
                <phase-template
                    :phase-id="project_phase.id"
                    :service-level-id="!!serviceLevels.length ? serviceLevels[0].id : 0"
                    :editable="editable"
                />
            </div>
            <div v-else
                v-for="service_level in serviceLevels"
                :key="service_level.id"
            >
                <h3 class="uk-accordion-title">
                    {{ service_level.name }}
                </h3>
                <div class="uk-accordion-content">
                    <phase-template
                        :phase-id="project_phase.id"
                        :service-level-id="service_level.id"
                        :editable="editable"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import PhaseTemplate from "./PhaseTemplate"

export default {
    components: {
        PhaseTemplate
    },
    props: {
        projectPhases: {
            validator: prop => (typeof prop === "object"),
            required: true
        },
        serviceLevels: {
            type: Array,
            required: true
        },
        editable: {
            type: Boolean,
            default: false
        }
    }
}
</script>
